import { BUNDLED_REFERENCE } from "./referenceData";

const modelGainsDoc = BUNDLED_REFERENCE["model-gains"];

export interface GainSub {
  sub: string;
  pct: number;
}
export interface GainClass {
  cls: string;
  pct: number;
  n: number;
  subs: GainSub[];
}
export interface ModelGain {
  key: string;
  label: string;
  nFeatures: number;
  classes: GainClass[];
}

export let HIGHRES_METHOD = modelGainsDoc.method;
export let HIGHRES_WHY = modelGainsDoc.why;
export const MODEL_GAINS: ModelGain[] = [...modelGainsDoc.models];

export interface ModelGainsDocument {
  method: string;
  why: string;
  models: ModelGain[];
}

export function installModelGains(doc: ModelGainsDocument): void {
  HIGHRES_METHOD = doc.method;
  HIGHRES_WHY = doc.why;
  MODEL_GAINS.splice(0, MODEL_GAINS.length, ...doc.models);
}
